export const TONE_OPTIONS = [
    {
        value: 'professional',
        labelKey: 'professionalTone',
        descriptionKey: 'professionalDescription'
    },
    {
        value: 'warm',
        labelKey: 'warmTone',
        descriptionKey: 'warmDescription'
    },
    {
        value: 'concise',
        labelKey: 'conciseTone',
        descriptionKey: 'conciseDescription'
    },
    {
        value: 'formal',
        labelKey: 'formalTone',
        descriptionKey: 'formalDescription'
    },
    {
        value: 'casual',
        labelKey: 'casualTone',
        descriptionKey: 'casualDescription'
    },
    {
        value: 'persuasive',
        labelKey: 'persuasiveTone',
        descriptionKey: 'persuasiveDescription'
    }
];

// Configuration constants
export const MAX_THOUGHTS_LENGTH = 5000;
export const MAX_CONTEXT_LENGTH = 10000;
export const COPY_FEEDBACK_DURATION = 2000;
export const API_TIMEOUT = 60000; // 60 seconds